/* eslint-disable indent */
import { ProgressDocument } from "@cs/lib/models/progress.model"
import { doc, getFirestore, onSnapshot, setDoc } from "@firebase/firestore"
import React, { FC, useEffect } from "react"
import { useAuthState } from "react-firebase-hooks/auth"
import { updateChapterState, updateQuiz } from "./actions"
import { ProgressContext, UpdateProgressType } from "./progress.context"
import { auth } from "@cs/lib/firebase/firebaseConfig"

export const ProgressWrapper: FC = ({ children }) => {
  const [user] = useAuthState(auth)
  const [progress, setProgress] = React.useState<ProgressDocument>({})
  useEffect(() => {
    if (!user) {
      setProgress({})
      return
    }
    const ref = doc(getFirestore(), "Progress", user?.uid)
    const unsub = onSnapshot(ref, progressDoc => {
      if (!progressDoc.exists()) {
        setDoc(ref, {})
      }
      setProgress(progressDoc.data() ?? {})
    })
    return () => unsub()
  }, [user])

  const updateProgress: UpdateProgressType = action => {
    switch (action.action) {
      case "updateQuiz": {
        return updateQuiz({
          ...action.args,
          user: user,
          setProgress,
        })
      }
      case "updateChapterState": {
        return updateChapterState({
          ...action.args,
          user: user,
          setProgress,
        })
      }
    }
  }

  return (
    <ProgressContext.Provider value={{ progress, updateProgress }}>
      {children}
    </ProgressContext.Provider>
  )
}
